import qs from 'qs'
import { Message } from 'element-ui'
import axios from 'axios';
import { encryptObj, decryptObj } from './appAes'
const { gatawayUrl } = window.__gconf

const request = axios.create({
  timeout: 30000,
  method: 'post',
  withCredentials: false
});

axios.defaults.baseURL = gatawayUrl

// 表单序列化
const serialize = data => {
  const list = []
  Object.keys(data).forEach(ele => {
    list.push(`${ ele }=${ data[ele] }`)
  })
  return list.join('&')
}

const isFileLike = val => {
  if (!val) return false
  if (typeof File !== 'undefined' && val instanceof File) return true
  if (typeof Blob !== 'undefined' && val instanceof Blob) return true
  return false
}

// HTTPrequest拦截
request.interceptors.request.use(config => {
  const method = (config.method || 'post').toLowerCase()
  const isGet = method === 'get'
  const rawData = isGet ? (config.params || {}) : (config.data || {})

  rawData['_token'] = localStorage.getItem('token')
  rawData['_agent_id'] = localStorage.getItem('agent_id') || 1

  const aesEnable = !!(window.__gconf && window.__gconf.aesEnable)
  const noEnc = parseInt(rawData.noenc) === 1 || (config.headers && String(config.headers['x-app-no-enc']) === '1')
  const shouldEnc = aesEnable && !noEnc

  if (config.dataType == 'formData') {
    config.headers['Content-Type'] = 'multipart/form-data'
    let formData = new FormData()

    if (shouldEnc) {
      const plain = {}
      Object.keys(rawData).forEach(key => {
        const val = rawData[key]
        if (isFileLike(val)) {
          formData.append(key, val)
        } else if (Array.isArray(val) && val.length && val.every(v => isFileLike(v))) {
          val.forEach(v => formData.append(key, v))
        } else {
          plain[key] = val
        }
      })
      const payload = encryptObj(plain)
      Object.keys(payload).forEach(k => {
        formData.append(k, payload[k])
      })
    } else {
      Object.keys(rawData).forEach(key => {
        const val = rawData[key]
        if (Array.isArray(val)) {
          val.forEach(v => formData.append(key, v))
        } else {
          formData.append(key, val)
        }
      })
    }

    config.data = formData
    config.params = config.params || {}
  } else {
    if (shouldEnc) {
      const payload = encryptObj(rawData)
      if (isGet) {
        config.params = payload
      } else {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        config.data = qs.stringify(payload)
      }
    } else {
      if (!isGet) {
        config.data = rawData
      } else {
        config.params = rawData
      }
      if (method === 'post' && config.headers && config.headers.serialize) {
        config.data = serialize(config.data)
        delete config.data.serialize
      }
    }
  }
  return config
}, error => {
  return Promise.reject(error)
})

request.interceptors.response.use(response => {
  try {
    if (response.status === 200) {
      let data = response.data
      const decrypted = decryptObj(data)
      if (decrypted !== null) data = decrypted

      if (data && data.err == '1') {
        Message.error(data.msg)
        return Promise.reject(new Error(data.msg || 'Error'))
      } else {
        return data
      }
    } else {
      return response
    }
  } catch (e) {
    return Promise.reject(e)
  }
}, error => {
  return Promise.reject(error)
})

export default request
